import { RoomSupplyItem } from "@/hooks/useRoomSupply"
import { useMobileLayoutProps } from "@/hooks/useMobileLayoutProps"

// ヘッダー/フッターの高さは index.tsx で1度だけ測り、各 View へはこの形で渡す。
export type MobileLayout = ReturnType<
    typeof useMobileLayoutProps<HTMLElement, HTMLElement>
>

// API の並び順を保ったままカテゴリごとにまとめる。
export const groupByCategory = (items: RoomSupplyItem[]) => {
    const groups: { category: string; items: RoomSupplyItem[] }[] = []
    for (const item of items) {
        const group = groups.find(g => g.category === item.category)
        if (group) {
            group.items.push(item)
        } else {
            groups.push({ category: item.category, items: [item] })
        }
    }
    return groups
}

// 品目の表示名。略称があれば略称を優先する（清掃員には正式名称より通りが良いため）
export const displayName = (item: { name?: string; shortName?: string }) =>
    item.shortName || item.name || ""
